import { generateEventID } from '../generateEventID/generateEventID.js';

/**
 * Dispatches a CustomEvent with the specified name and optional payload to the `window` object.
 *
 * @param eventName - The name of the event to dispatch.
 * @param data - Optional payload to include in the event's `detail` property.
 * @returns Always returns `false`.
 *
 * @example
 * ```ts
 * dispatchExternalEvent('user-logged-in', { userId: 123 });
 * ```
 */
function dispatchExternalEvent(eventName, data) {
    window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
    return false;
}
/**
 * Dispatches a CustomEvent with the specified name and optional payload to the `window` object,
 * and optionally pushes the event to Google Tag Manager's `dataLayer` if 'gtm' is included in the `clients` array.
 *
 * @param eventName - The name of the event to dispatch.
 * @param data - Optional payload to include in the event's `detail` property and in the dataLayer push.
 * @param clients - Optional array of client identifiers. If 'gtm' is present, the event is also pushed to `window.dataLayer`.
 * @returns Always returns `false`.
 *
 * @example
 * ```ts
 * dispatchEventForClients('purchase', { amount: 100 }, ['gtm']);
 * ```
 */
function dispatchEventForClients(eventName, data, clients) {
    window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
    if (clients?.indexOf('gtm') !== -1) {
        window.dataLayer?.push({
            event: eventName,
            ss_event_id: generateEventID(),
            ...data,
        });
    }
    return false;
}

export { dispatchEventForClients, dispatchExternalEvent };
//# sourceMappingURL=dispatchExternalEvent.js.map
